<div class="kf-editable-field">
    <div class="d-flex
         {{'kf-field-xs-' + labelCols}}
         {{'kf-field-sm-' + labelColsSm}}
         {{'kf-field-md-' + labelColsMd}}
         {{'kf-field-lg-' + labelColsLg}}
         {{'kf-field-xl-' + labelColsXl}}
         {{'kf-field-xxl-' + labelColsXxl}}">
        <div class="kf-input-label">
            <div class="kf-label">
                {{label}}
                @if (helpText) {
                    <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                        <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                    </span>
                }
            </div>
        </div>
        
        <!-- INPUT BOX -->
        <div class="kf-input col">
            @if (isEditable$ | async; as editable) {
                <div class="d-flex justify-content-between mb-1">
                    <div class="d-flex">
                        @for (group of buttonGroups; track group; let last = $last) {
                            <div class="d-flex">
                                @for (button of group; track button; let last = $last) {
                                    <!--  TEXT COLOR PICKER BUTTON  -->
                                    @if (button.action == 'forecolor') {
                                        <div class="btn-group">
                                            <button type="button" class="kf-btn-xs kf-btn kf-btn-light-gray kf-btn-rti-font-color rounded-start h-auto"
                                                    [ngStyle]="{'color': selectedTextColor}"
                                                    (click)="editText(button.action)"
                                                    title="{{button.label}}"
                                                    [disabled]="!obj[prop]">
                                                <i class="{{button.icon}}"></i><span class="sr-only">{{button.label}}</span>
                                            </button>
                                            <button type="button" class="kf-btn-xs kf-btn kf-btn-blue rounded-end h-auto dropdown-toggle dropdown-toggle-split me-1"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    [disabled]="!obj[prop]">
                                                <span class="sr-only">Pick a text color</span>
                                            </button>
                                            <ul class="dropdown-menu kf-unset-min-width p-1">
                                                @for (colorGroup of colorOptions; track colorGroup) {
                                                    <li>
                                                        @for (color of colorGroup; track color; let last = $last) {
                                                            <span class="rounded px-2 me-1 kf-cursor-pointer" [class.me-1]="!last"
                                                                  [ngStyle]="{'background-color': color}"
                                                                  (click)="selectColor(color)"></span>
                                                        }
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    <!--  ALL OTHER EDIT BUTTONS  -->
                                    @if (button.action != 'forecolor') {
                                        <button class="kf-btn-xs kf-btn kf-btn-blue h-auto"
                                                [class.me-1]="!last"
                                                (click)="editText(button.action)"
                                                title="{{button.label}}"
                                                [disabled]="!obj[prop]">
                                            <i class="{{button.icon}}"></i><span class="sr-only">{{button.label}}</span>
                                        </button>
                                    }
                                }
                                @if (!last) {
                                    <div class="vr mx-2 h-100"></div>
                                }
                            </div>
                        }
                    </div>
                    @if (maxLength) {
                        <div class="text-end kf-element" [class.kf-text-danger-red]="obj[prop]?.length > maxLength">
                            <small class="fst-italic">{{obj[prop]?.length ?? 0}}/{{maxLength}}</small>
                        </div>
                    }
                </div>
            }
            <!--  EDITABLE DIV  -->
            <div class="d-flex">
                <div [attr.contenteditable]="(isEditable$ | async)"
                     class="w-100 p-1 text-break overflow-auto rich-text-placeholder"
                     [class.editable-rich-text]="(isEditable$ | async)"
                     [ngStyle]="{'height': !!defaultHeight ? defaultHeight + 'px' : 'inherit'}"
                     [attr.maxlength]="maxLength"
                     (input)="onChange()"
                     (blur)="onBlur(); onChange()"
                     (paste)="onPaste($event)"
                     [attr.data-placeholder]="(isEditable$ | async) ? placeholder : ''" #richTextInput></div>
            </div>
        </div>
    </div>
    
    <!--  Errors/Warnings  -->
    @if (isEditable$ | async) {
        <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true"></observable-errors-warnings>
    }
</div>
